<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Create a new quote</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-quote-forms [account]='this.account' [site]='this.site' [quote]='this.quote' [quoteLines]='this.quoteLines'></app-quote-forms>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/quoting'>Cancel</button>
    </form>
  </div>
</div>
